import styled from 'styled-components';

import { WORKFLOW_STEP_CARD_HEIGHT } from 'dashboard/views/DashboardInquiryAnalyticsFunnelV2View/InquiryFunnelStepCard';
import {
  HORIZONTAL_LINE_TOP_MARGIN,
  StepFlowHorizontalLine,
} from 'dashboard/views/DashboardInquiryAnalyticsFunnelV2View/StepFlowElements';

interface InquiryFunnelTreeConnectorProps {
  id: string;
  lineColor?: string;
  borderColor: string;
  pathRatio: number;
}

const CONTAINER_PADDING_LEFT_RIGHT = 6;
const Container = styled('div')<{ active: boolean; expanded: boolean; width: number }>`
  position: relative;
  min-height: ${WORKFLOW_STEP_CARD_HEIGHT}px;
  width: ${({ width }) => width}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-left: ${CONTAINER_PADDING_LEFT_RIGHT}px;
  padding-right: ${CONTAINER_PADDING_LEFT_RIGHT}px;
  ${({ active }) => active && 'cursor: pointer;'}
  transition: min-height .25s;
  ${({ expanded, theme }) => expanded && `border-radius: ${theme.card.borderRadius};`}
`;

const TREE_CONNECTOR_WIDTH = 48;

export const InquiryFunnelTreeConnector = ({
  id,
  lineColor,
  pathRatio,
  borderColor,
}: InquiryFunnelTreeConnectorProps) => {
  return (
    <Container
      id={`workflow-tree__add-step-button-${id}`}
      data-test={`workflow-tree__add-step-button-${id}`}
      width={TREE_CONNECTOR_WIDTH}
      active={true}
      expanded={true}
      // While dragging a step card, this listener is called unintentionally somehow
    >
      <StepFlowHorizontalLine
        color={lineColor}
        borderColor={borderColor}
        height={WORKFLOW_STEP_CARD_HEIGHT - HORIZONTAL_LINE_TOP_MARGIN}
        strokeRatio={pathRatio}
      />
    </Container>
  );
};
